import { Outlet } from '@solidjs/router';
import { Show, createMemo } from 'solid-js';
import { usePropertyManagerPermissions } from '~/contexts/global';
import { AccessDeniedFallback } from './AccessDeniedFallback';
import { AccessGuardLoading } from './AccessGuardLoading';
import type { Component, JSX, ParentProps } from 'solid-js';

interface PermissionGuardProps {
  resource: string;
  action: string;
  fallback?: JSX.Element;
}

export const PermissionGuard: Component<ParentProps<PermissionGuardProps>> = (props) => {
  const { hasPermission, permissionsReady } = usePropertyManagerPermissions();
  const canAccess = createMemo(() => {
    return hasPermission(props.resource, props.action);
  });

  return (
    <Show when={permissionsReady()} fallback={<AccessGuardLoading />}>
      <Show
        when={canAccess()}
        fallback={
          <Show when={!props.fallback} fallback={props.fallback}>
            <AccessDeniedFallback />
          </Show>
        }>
        {props.children || <Outlet />}
      </Show>
    </Show>
  );
};
